// src/types.ts
export interface Pessoa {
  id?: string;            // mapeia o "uid"
  nome: string;           // mapeia o "name"
  email?: string;         // mapeia o "email"
  cpf: string;            // mapeia o "cpf" (CPF ou passaporte)
  telefone?: string;
  inscricao?: string;
  categoria?: string;
  checkin?: string;
  tipoIngresso?: string;  // tipo do ingresso (Executivo, Acesso VIP, etc.)
  customFields?: Record<string, any>;
  registrationUid?: string;
  /** Codigo impresso no QR do cracha. Cai no registrationUid quando ausente. */
  credentialCode?: string; // mapeia o "registrationUid"
  checkinCount?: number;    // contador de check-ins
  /** Quando a credencial foi entregue (último check-in), ISO vindo do servidor. */
  ultimoCheckin?: string | null;
}

/**
 * Campos do cadastro feito na secretaria.
 *
 * Os obrigatórios vêm do briefing v2, pág. 4: CPF ou CNPJ, nome completo, empresa,
 * telefone, data de nascimento, e-mail, conselho profissional e nacionalidade.
 *
 * A nacionalidade governa o documento: brasileiro exige CPF ou CNPJ; estrangeiro dispensa
 * e passa a exigir passaporte ou NIF. O campo é texto livre porque cada país usa um
 * formato — o briefing pede explicitamente que seja alfanumérico e sem tamanho fixo.
 */
export type Nacionalidade = 'brasileiro' | 'estrangeiro';

export interface NovoCadastroForm {
  nome: string;
  cpf: string;
  email: string;
  celular: string;
  tipoIngresso?: string;
  authorization: boolean;
  nacionalidade: Nacionalidade;
  passaporteOuNif: string;
  empresa: string;
  dataNascimento: string;
  conselhoProfissional: string;
  registroProfissional: string;
  estadoUf: string;
}

/**
 * Valores usados pela SBAM na planilha — mantidos idênticos para a regra do CFM funcionar.
 *
 * "DIRETORIA SBAM" não é conselho profissional: é o que a SBAM manda imprimir no crachá dos
 * nove diretores, no lugar do conselho. Precisa estar aqui porque o campo é obrigatório e a
 * lista é fechada — sem a opção, abrir a ficha de um diretor e salvar trocaria o valor por
 * um da lista, e o crachá dele voltaria a dizer "Medicina - CFM".
 */
export const CONSELHOS = [
  'Medicina - CFM',
  'Enfermagem - COREN',
  'Farmácia - CRF',
  'Fisioterapia/Terapia Ocupacional - COFFITO',
  'Odontologia - CFO',
  'Nutrição - CFN',
  'Psicologia - CFP',
  'DIRETORIA SBAM',
  'Sem registro em conselho.',
] as const;

/**
 * Estados no MESMO formato que a planilha da SBAM usa: "Nome (UF)".
 *
 * O formato importa. A base já tem as duas formas — "São Paulo (SP)" da planilha e "SP"
 * digitado à mão — e o mesmo estado chegou a aparecer duas vezes na contagem. O relatório
 * normaliza os dois, mas gravar já no formato da importação evita criar variante nova.
 */
export const ESTADOS = [
  'Acre (AC)',
  'Alagoas (AL)',
  'Amapá (AP)',
  'Amazonas (AM)',
  'Bahia (BA)',
  'Ceará (CE)',
  'Distrito Federal (DF)',
  'Espírito Santo (ES)',
  'Goiás (GO)',
  'Maranhão (MA)',
  'Mato Grosso (MT)',
  'Mato Grosso do Sul (MS)',
  'Minas Gerais (MG)',
  'Pará (PA)',
  'Paraíba (PB)',
  'Paraná (PR)',
  'Pernambuco (PE)',
  'Piauí (PI)',
  'Rio de Janeiro (RJ)',
  'Rio Grande do Norte (RN)',
  'Rio Grande do Sul (RS)',
  'Rondônia (RO)',
  'Roraima (RR)',
  'Santa Catarina (SC)',
  'São Paulo (SP)',
  'Sergipe (SE)',
  'Tocantins (TO)',
] as const;
